import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './permission' // permission control 菜单加载
import Uploader from 'vue-simple-uploader'
import VueCropper from 'vue-cropper'
import BaiduMap from 'vue-baidu-map'

import './assets/js/all.js'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/tipicons.css'
import elementUI from "element-ui"
import elementUIVerify from 'element-ui-verify'

import permission from './directive/permission'
import { parseTime, resetForm, selectDictLabel, listParseIntByKey, dictFormatter, getRegionCode, formatterRegionCode } from "@/utils/common";
import Cookies from 'js-cookie'
Vue.prototype.parseTime = parseTime;
Vue.prototype.resetForm = resetForm;
Vue.prototype.selectDictLabel = selectDictLabel;
Vue.prototype.listParseIntByKey = listParseIntByKey;
Vue.prototype.dictFormatter = dictFormatter;
Vue.prototype.getRegionCode = getRegionCode;
Vue.prototype.formatterRegionCode = formatterRegionCode;
Vue.prototype.Cookies = Cookies;
Vue.prototype.$IsMobile = navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
)

import Pagination from "./components/Pagination";
import RightToolbar from "./components/RightToolbar" // 自定义表格工具扩展-刷新/搜索

Vue.prototype.resetForm = resetForm;
// 全局注册
Vue.prototype.msgSuccess = function (msg) {
    this.$message({ showClose: true, message: msg, type: "success" });
}

Vue.prototype.msgError = function (msg) {
    this.$message({ showClose: true, message: msg, type: "error" });
}

Vue.prototype.msgInfo = function (msg) {
    this.$message.info(msg);
}

//全局挂载
Vue.component('Pagination', Pagination)
Vue.component('RightToolbar', RightToolbar)

Vue.use(permission)

Vue.use(elementUI, {
    //size: 'small' // set element-ui default size
})

Vue.use(BaiduMap, { ak: 'UMT13FmEcV6XWI7SY9G695OeVPSMip2B' })
// Vue.use(permission)
Vue.use(elementUIVerify)
Vue.use(Uploader);
Vue.use(VueCropper)
Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
